import { render, staticRenderFns } from "./AvatarCategoriesList.vue?vue&type=template&id=3306ea08&"
import script from "./AvatarCategoriesList.vue?vue&type=script&lang=js&"
export * from "./AvatarCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports